import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import AddressCollapse from './AddressCollapse';
import { CheckoutStepsWrapper } from './CheckoutSteps.styled';
import PaymentCollapse from './PaymentCollapse';

type Props = {};

export default function CheckoutSteps({}: Props) {
  const [addressCollapseIsOpen, setAddressCollapseIsOpen] = useState(true);
  const [paymentCollapseIsOpen, setPaymentCollapseIsOpen] = useState(false);
  const { data } = useSelector((state: RootState) => state.checkout);

  return (
    <CheckoutStepsWrapper>
      <AddressCollapse
        isOpen={addressCollapseIsOpen}
        setIsOpen={setAddressCollapseIsOpen}
        setPaymentCollapseIsOpen={setPaymentCollapseIsOpen}
      />
      <PaymentCollapse
        isOpen={paymentCollapseIsOpen}
        setIsOpen={setPaymentCollapseIsOpen}
        setAddressCollapseIsOpen={setAddressCollapseIsOpen}
      />
    </CheckoutStepsWrapper>
  );
}
